<!--
Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<!-- Place the card directly inside a container grid which applies a 3 column grid layout.
     Do not define the number of rows explicitly, the card can implicitly take
     up to 4 CSS grid rows depending on the content and wrapping needs. E.g. CSS:
     .card-grid {
        display: grid;
        grid-template-columns: auto 1fr auto;
     } -->

<!-- Spacing -->
<div class="spacer"></div>
<!-- Lead -->
@if (data?.lead) {
    <nv-hig-list-item-lead [cardData]="data.lead"></nv-hig-list-item-lead>
}
<!-- Core -->
<nv-hig-list-item-core [cardData]="data.core"></nv-hig-list-item-core>
<!-- Trail -->
@if (data?.trail) {
    <nv-hig-list-item-trail
        [cardData]="data.trail"
        [openDropdownAsPopup]="openDropdownAsPopup"
        [dialogPanelClass]="dialogPanelClass"
        [spinnerDiameter]="spinnerDiameter"
        [useDifferForUpdate]="useDifferForUpdate"
        (primaryButtonClicked)="primaryButtonClick($event)"
        (secondaryButtonClicked)="secondaryButtonClick($event)"
        (toggleClicked)="toggleClick($event)"
        (selectionChanged)="selectionChange($event)"
    ></nv-hig-list-item-trail>
}
<!-- List Insert as context -->
@if (data?.context) {
    <nv-hig-list-insert
        [data]="data.context"
        [textColor]="'font-color-tertiary'"
        (primaryButtonClicked)="primaryContextButtonClick($event)"
        (secondaryButtonClicked)="secondaryContextButtonClick($event)"
    ></nv-hig-list-insert>
}
<div class="spacer"></div>
